import { render, staticRenderFns } from "./FrotaDriverList.vue?vue&type=template&id=90994d90"
import script from "./FrotaDriverList.vue?vue&type=script&lang=js"
export * from "./FrotaDriverList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports